export const GET_SCHOOLS = 'schools/GET_SCHOOLS';
export const CREATE_SCHOOL = 'schools/CREATE_SCHOOL';
